import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { forwardRef, useImperativeHandle, useState } from "react";
import GlobalButton from "../CustomButton";
import DialogBody from "./Body";
import DialogActionButtons from "./Footer";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiPaper-root": {
    width: "500px",
    [theme.breakpoints.down("sm")]: {
      margin: 12,
    },
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(2),
  },
}));

const DialogHeader = styled(DialogTitle)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  padding: theme.spacing("12px 16px"),
  fontSize: "1.25rem",
  fontWeight: 600,
  [theme.breakpoints.down("sm")]: {
    fontSize: "1rem",
    padding: "12px 16px",
  },
}));

const CategoryBlockConfirmDialog = forwardRef(({ handleConfirm }, ref) => {
  const [open, setOpen] = useState(false);
  const [paramsData, setParamsData] = useState(null);
  const { t } = useTranslation(["common"]);

  useImperativeHandle(ref, () => ({
    openDialog(params) {
      setOpen(true);
      setParamsData(params);
    },
    closeDialog() {
      setOpen(false);
      setParamsData(null);
    },
  }));

  const handleClose = () => {
    setOpen(false);
    setParamsData(null);
  };

  const isBlocking = paramsData?.event;

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogHeader>
        {isBlocking ? t("unblockCategory") : t("blockCategory")}
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{ color: "white" }}
        >
          <CloseIcon />
        </IconButton>
      </DialogHeader>

      <DialogBody>
        <Typography variant="body2" my={1}>
          {!isBlocking ? t("blockImpact") : t("unblockImpact")}
        </Typography>
        {!isBlocking && paramsData !== null && (
          <Typography variant="body2" my={1} color="error.main">
            ⚠️ {t("note")}: {t("blockPerformanceWarning")}
          </Typography>
        )}
      </DialogBody>
      <DialogActionButtons
        onConfirm={() => handleConfirm(paramsData)}
        onCancel={handleClose}
        confirmText={"yes"}
        cancelText={"cancel"}
        isConfirmBtnDisable={false}
        showCancelButton={true}
      />
    </BootstrapDialog>
  );
});

export default CategoryBlockConfirmDialog;
